<template>
  <svg
    width="10"
    height="10"
    viewBox="0 0 10 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_2361_29902)">
      <path
        d="M5 9.6875C5.9271 9.6875 6.83338 9.41258 7.60424 8.89752C8.37509 8.38245 8.9759 7.65036 9.33068 6.79383C9.68547 5.9373 9.7783 4.9948 9.59743 4.08552C9.41656 3.17623 8.97012 2.341 8.31456 1.68544C7.659 1.02988 6.82377 0.583439 5.91449 0.402571C5.0052 0.221703 4.0627 0.314531 3.20617 0.669317C2.34964 1.0241 1.61756 1.62491 1.10249 2.39577C0.587417 3.16662 0.3125 4.0729 0.3125 5C0.3125 6.2432 0.80636 7.43549 1.68544 8.31456C2.56451 9.19364 3.7568 9.6875 5 9.6875ZM5 2.06875C5.12361 2.06875 5.24445 2.10541 5.34723 2.17408C5.45001 2.24276 5.53012 2.34037 5.57743 2.45457C5.62473 2.56878 5.63711 2.69445 5.61299 2.81568C5.58888 2.93692 5.52935 3.04829 5.44194 3.13569C5.35453 3.2231 5.24317 3.28263 5.12193 3.30674C5.00069 3.33086 4.87503 3.31848 4.76082 3.27118C4.64662 3.22387 4.54901 3.14376 4.48033 3.04098C4.41166 2.9382 4.375 2.81737 4.375 2.69375C4.375 2.52799 4.44085 2.36902 4.55806 2.25181C4.67527 2.1346 4.83424 2.06875 5 2.06875ZM4.375 5C4.375 4.83424 4.44085 4.67527 4.55806 4.55806C4.67527 4.44085 4.83424 4.375 5 4.375C5.16576 4.375 5.32473 4.44085 5.44194 4.55806C5.55915 4.67527 5.625 4.83424 5.625 5V7.5C5.625 7.66576 5.55915 7.82473 5.44194 7.94194C5.32473 8.05915 5.16576 8.125 5 8.125C4.83424 8.125 4.67527 8.05915 4.55806 7.94194C4.44085 7.82473 4.375 7.66576 4.375 7.5V5Z"
        fill="#FF6347"
      />
    </g>
    <defs>
      <clipPath id="clip0_2361_29902">
        <rect width="10" height="10" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
